import { createFileRoute } from '@tanstack/react-router';
import { AppShell } from '@/components/AppShell';
import { UpcomingView } from '@/features/upcoming/UpcomingView';

export const Route = createFileRoute('/upcoming')({
  component: () => (
    <AppShell>
      <UpcomingView />
    </AppShell>
  ),
});
